<template>
  <!-- 教学团队 -->
  <div class="teaching-team">
    <div class="teaching-team_div">
      <div class="home-title">
        <img src="@/assets/left.png" alt="" class="teaching-team_img">
        <div class="home-title-main">
          <p> 过硬的教学团队</p>
          <p> 资历能力皆备，保证高水平教学质量</p>
        </div>
        <img src="@/assets/right.png" alt="" class="teaching-team_img">
      </div>
    </div>
    <div style="width:1100px; height:545px; margin:40px auto;height:545px">
      <!-- Using the slider component -->
      <slider ref="teaching-slider" :options="teachingOptions">
        <!-- slideritem wrapped package with the components you need -->
        <slideritem style="pointer-events: none;" v-for="(item,index) in someList1" :key="index">
          <img :src="item.image" class="teacher-image">
         <!-- <div class="teaching-info">
            <p class="teaching-name">{{item.name}}</p>
            <p class="teaching-experience">{{item.experience}}</p>
            <p class="teaching-remark" v-html="item.remark"></p>
            <p class="teaching-qualifications">{{item.qualifications}}</p>
          </div>
          <img src="../../../assets/teaching_bottom.png" class="teacher-bottom"> -->
        </slideritem>
        <!-- Customizable loading -->
        <div slot="loading">loading...</div>
      </slider>
    </div>
  </div>
</template>
<script>
  // import slider components
  import {
    slider,
    slideritem
  } from 'vue-concise-slider'
  export default {
    name: 'teaching',
    data() {
      return {
        // data list [array]
        someList1: [],
        // Slider configuration [obj]
        teachingOptions: {
          direction: 'vertical', // 方向设置，垂直滚动
          autoplay: 5000,
          thresholdDistance: 100, // Sliding distance threshold
          thresholdTime: 300, // Sliding time threshold decision
          grabCursor: true, // Scratch style
          speed: 300 // Sliding speed
        }
      }
    },
    created() {
      this.getTeacherApi()
    },
    methods: {
      getTeacherApi() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/teacher/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            is_home: 1
          }
        }).then(res => {
          this.someList1 = res.data.data.data
          // console.log(this.someList1)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    components: {
      slider,
      slideritem
    }
  }
</script>
<style scoped>
  /********** 教学团队 **********/
  .teaching-team {
    width: 100%;
    height: auto;
    margin: 100px auto 80px;
    padding-top: 10px;
  }

  .teacher-bottom {
    bottom: 0;
    width: 100%;
    position: absolute;
  }

  .teaching-team_div {
    height: 100%;
  }

  .slider_img {
    width: 1100px;
    height: 545px;
    margin: 0 auto;
    /* position: relative; */
  }

  .teacher-image {
    float: left;

    height: 545px;
  }

  .slider-item {
   /* background: url('../../../assets/teaching.png') no-repeat; */
    background-size: 100% 100%;
  }

  .teaching-info {
    width: 350px;
    height: 350px;
    text-align: left;
    margin: 20px 30px 0 85px
  }

  .teaching-info p:nth-child(1) {
    font-size: 26px;
    color: #3c51e0;
    font-weight: 600;
  }

  .teaching-info p:nth-child(2) {
    font-size: 10px;
    color: #a0a2a1;
    margin-top: 15px;
    margin-bottom: 25px;
  }

  .teaching-info p:nth-child(4) {
    font-size: 15px;
    color: #333333;
    font-weight: 600;
    margin-top: 25px;
  }

  .teaching-info p:nth-child(3) {
    white-space: normal;
    width: 300px;
    font-size: 15px;
    color: #555;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Homes/teaching.vue